import React from 'react';

const ProductFeatures = ({ product }) => {
  if (!product || !product.Features) {
    return null;
  }

  // Handle Features as string, array, or object
  let featuresArray = [];
  
  if (typeof product.Features === 'string') {
    // If it's a string, split by newlines or commas
    featuresArray = product.Features.split(/\n|,/).map(f => f.trim()).filter(f => f);
  } else if (Array.isArray(product.Features)) {
    featuresArray = product.Features;
  } else if (typeof product.Features === 'object') {
    // If it's an object, try to extract values
    featuresArray = Object.values(product.Features).filter(f => f);
  }

  if (featuresArray.length === 0) {
    return null;
  }

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-catalina-blue mb-4">
            Key Features
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Discover what makes this product stand out from the rest
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {featuresArray.map((feature, index) => {
            // Handle different feature data types
            const featureText = typeof feature === 'string' 
              ? feature 
              : feature?.text || feature?.title || feature?.description || JSON.stringify(feature);
            
            return (
              <div
                key={index}
                className="bg-white rounded-lg p-6 shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100"
              >
                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-catalina-blue/10 text-catalina-blue">
                      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                  </div>
                  <div className="ml-4">
                    <p className="text-gray-700 leading-relaxed">
                      {featureText}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProductFeatures;